import { motion } from "framer-motion";
import styled from "styled-components";
import {
  BORDER_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { FONT_WEIGHT } from "../../../constants/design/fontWeight";
import {
  BORDER_RADIUS,
  COMPONENTS,
  SPACING,
} from "../../../constants/design/spacing";
import { SelectButton } from "../Select/style";
import { fadeInCSS } from "../style";

export const DropdownButton = styled(SelectButton)`
  ${FONT_CSS.body.three}
  display: flex;
  border-radius: 8px;
  font-weight: ${FONT_WEIGHT.medium};
  background-color: ${LAYER_COLORS.two};

  height: 100%;
  margin: auto 0;

  > * {
    margin: auto;
    width: 100%;
  }
`;

export const DropdownHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  background-color: ${LAYER_COLORS.one};
`;

export const DropdownMenuWrapper = styled.ul<{ hasAnnouncement?: boolean }>`
  background-color: ${LAYER_COLORS.one};
  /* The menu keeps its Bootstrap className -- unlike the toggle and the items,
     which drop it -- because .dropdown-menu is display:none and .show is what
     reveals it, so removing the class would leave every menu open forever.
     Bootstrap comes with color:#212529 attached, near-black on this near-black
     surface. The items set their own colour, but a header/footer/separator
     added later would not, so state it here instead of relying on that. */
  color: ${TEXT_COLORS.one};
  outline: ${`1px solid ${BORDER_COLORS.one}`};
  border: none;
  overflow-y: scroll;
  max-height: ${({ hasAnnouncement }) =>
    `calc(100vh - ${
      COMPONENTS.header.main +
      COMPONENTS.header.sub +
      COMPONENTS.footer.desktop +
      SPACING.three +
      (hasAnnouncement ? COMPONENTS.banner : 0)
    }px)`};
  border-radius: ${BORDER_RADIUS.five}px;
  padding: 0;
  z-index: 3;
  ${fadeInCSS}
`;

export const DropdownItemButton = styled(motion.button)`
  ${FONT_CSS.body.three}
  color: ${TEXT_COLORS.one};
  width: 100%;
  text-align: left;
  padding: 0;

  /* The selected row, for the callers that mark one (the RFQ dropdowns pass
     'active:'). Bootstrap used to paint this via '.dropdown-item.active', and
     dropping 'className' -- which was right, it painted the row Bootstrap blue
     on a dark theme -- left those dropdowns with NO selected state at all.

     Keyed off the 'aria-selected' the library already emits, so the visual and
     the accessible state cannot drift apart. Weight as well as background, so
     the cue does not rely on colour alone. */
  &[aria-selected="true"] {
    font-weight: ${FONT_WEIGHT.bold};
    background-color: ${LAYER_COLORS.three};
  }
`;

export const ChevronWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  margin: 0;
  margin-left: auto;
`;
